function filterLooxFiveStarReviews() {
  const widgets = document.querySelectorAll('loox-snippets-widget');

  widgets.forEach((widget) => {
    const shadowRoot = widget.shadowRoot;

    if (!shadowRoot) return;

    const reviews = shadowRoot.querySelectorAll('.quickview-button');

    reviews.forEach((review) => {
      const rating = review.querySelector('.rating');

      if (!rating) return;

      const ratingText = rating.getAttribute('aria-label') || '';

      if (ratingText !== 'Rating icons: 5 / 5') {
        review.style.display = 'none';
      } else {
        review.style.display = '';
      }
    });
  });
}

filterLooxFiveStarReviews();

const looxObserver = new MutationObserver(() => {
  filterLooxFiveStarReviews();
});

looxObserver.observe(document.body, {
  childList: true,
  subtree: true
});